import { useState, useRef, useEffect } from "react";

// ── DESIGN TOKENS ──────────────────────────────────────────────────────────
const R = "#c0392b";
const NAVY = "#0f172a";
const NAVY2 = "#1e293b";
const MUTED = "#64748b";
const BORDER = "#e2e8f0";
const BG = "#f1f5f9";
const WHITE = "#ffffff";
const GREEN = "#16a34a";
const AMBER = "#d97706";
const BLUE = "#2563eb";

// ── MOCK DATA ──────────────────────────────────────────────────────────────
const USER = { name: "Manoj Shah", company: "Rallis India Ltd", mobile: "9820012345", email: "manoj.shah@rallis.co.in", kam: "Mohit Pandey", kam_phone: "9820099001", credit_limit: 2000000, credit_used: 1422500 };

const SHIPMENTS = [
  { cn: "CN-2026-4521", lr: "LR-D-88991", from: "Delhi", to: "Mumbai", consignee: "Rallis Mumbai Depot", pkgs: 240, weight: "6,200 kg", booked: "2026-04-04", status: "In Transit", eta: "2026-04-07", vehicle: "DL01AB1234", driver: "Rajan Kumar", route_pct: 68, material: "Agrochemicals", invoice: "INV-RAL-8821" },
  { cn: "CN-2026-4418", lr: "LR-D-88840", from: "Mumbai", to: "Chennai", consignee: "Rallis Chennai Store", pkgs: 180, weight: "4,800 kg", booked: "2026-03-30", status: "Delivered", eta: "2026-04-03", vehicle: "MH04CD5678", driver: "Suresh Nair", route_pct: 100, material: "Pesticides", invoice: "INV-RAL-8790", delivered: "2026-04-03 14:22", pod: true },
  { cn: "CN-2026-4390", lr: "LR-D-88812", from: "Pune", to: "Ahmedabad", consignee: "Rallis Ahmedabad", pkgs: 96, weight: "2,400 kg", booked: "2026-03-28", status: "Out for Delivery", eta: "2026-04-06", vehicle: "MH14GH9012", driver: "Vijay Patil", route_pct: 92, material: "Fungicides", invoice: "INV-RAL-8768" },
  { cn: "CN-2026-4312", lr: "LR-D-88734", from: "Delhi", to: "Kolkata", consignee: "Rallis East India", pkgs: 320, weight: "8,100 kg", booked: "2026-03-25", status: "Delivered", eta: "2026-03-30", vehicle: "WB02EF3456", driver: "Arun Das", route_pct: 100, material: "Herbicides", invoice: "INV-RAL-8712", delivered: "2026-03-30 11:45", pod: true },
  { cn: "CN-2026-4298", lr: "LR-D-88720", from: "Mumbai", to: "Nagpur", consignee: "Rallis Nagpur", pkgs: 120, weight: "3,200 kg", booked: "2026-04-06", status: "Booked", eta: "2026-04-08", vehicle: null, driver: null, route_pct: 0, material: "Agrochemicals", invoice: "INV-RAL-8860" },
];

const INVOICES = [
  { inv: "INV-2026-0892", cn: "CN-2026-4312", date: "2026-02-20", due: "2026-03-22", amount: 284500, paid: 0, aging: 45, status: "Overdue" },
  { inv: "INV-2026-0845", cn: "CN-2026-4298", date: "2026-03-05", due: "2026-04-04", amount: 192000, paid: 0, aging: 32, status: "Overdue" },
  { inv: "INV-2026-0801", cn: "CN-2026-4390", date: "2026-03-19", due: "2026-04-18", amount: 345000, paid: 0, aging: 18, status: "Due Soon" },
  { inv: "INV-2026-0756", cn: "CN-2026-4418", date: "2026-03-30", due: "2026-04-29", amount: 412000, paid: 0, aging: 7, status: "Current" },
  { inv: "INV-2026-0723", cn: "CN-2026-4521", date: "2026-04-05", due: "2026-05-05", amount: 189000, paid: 0, aging: 1, status: "Current" },
];

const UNBILLED = [
  { cn: "CN-2026-4521", lr: "LR-D-88991", route: "Delhi → Mumbai", date: "2026-04-04", pkgs: 240, weight: "6,200 kg", material: "Agrochemicals", days: 2 },
  { cn: "CN-2026-4298", lr: "LR-D-88720", route: "Mumbai → Nagpur", date: "2026-04-06", pkgs: 120, weight: "3,200 kg", material: "Agrochemicals", days: 0 },
  { cn: "CN-2026-4201", lr: "LR-D-88621", route: "Pune → Bangalore", date: "2026-04-01", pkgs: 80, weight: "2,100 kg", material: "Seeds", days: 5 },
  { cn: "CN-2026-4188", lr: "LR-D-88608", route: "Delhi → Hyderabad", date: "2026-03-29", pkgs: 160, weight: "4,400 kg", material: "Pesticides", days: 8 },
];

const GRIEVANCES = [
  { id: "GRV-2026-0045", cn: "CN-2026-4312", type: "Damage / Shortage", subject: "Partial damage to 12 bags of fungicide reported at Kolkata delivery", raised: "2026-04-01", status: "In Progress", priority: "High", sla_hours: 48, elapsed_hours: 22, assigned: "Kapil Agarwal", updates: [{ time: "2026-04-01 10:30", msg: "Ticket raised. Assigned to Kapil Agarwal." }, { time: "2026-04-02 14:00", msg: "Driver statement collected. Photos received. Insurance claim initiated." }, { time: "2026-04-03 09:00", msg: "Claim under review. BRL surveyor scheduled for Apr 7." }] },
  { id: "GRV-2026-0039", cn: "CN-2026-4201", type: "Transit Delay", subject: "Consignment delayed by 3 days on Pune-Bangalore route", raised: "2026-03-22", status: "Resolved", priority: "Medium", sla_hours: 24, elapsed_hours: 18, assigned: "Mohit Pandey", updates: [{ time: "2026-03-22 11:00", msg: "Delay reported. Vehicle breakdown on NH48." }, { time: "2026-03-23 16:00", msg: "Replacement vehicle deployed. Shipment resumed." }, { time: "2026-03-25 09:30", msg: "Delivered. Delay compensation credit note issued." }] },
  { id: "GRV-2026-0031", cn: "CN-2026-4188", type: "Invoice Dispute", subject: "Extra charges of ₹8,400 billed - not agreed in rate contract", raised: "2026-03-15", status: "Resolved", priority: "Low", sla_hours: 72, elapsed_hours: 48, assigned: "Bhimsen Sharma", updates: [{ time: "2026-03-15 14:00", msg: "Dispute raised. Rate contract shared." }, { time: "2026-03-17 11:00", msg: "Credit note issued for ₹8,400." }] },
];

const LEDGER = [
  { date: "2026-04-05", ref: "INV-2026-0723", type: "Invoice", debit: 189000, credit: 0, balance: 1422500 },
  { date: "2026-04-01", ref: "GRV-0039 CN", type: "Credit Note", debit: 0, credit: 8400, balance: 1233500 },
  { date: "2026-03-30", ref: "INV-2026-0756", type: "Invoice", debit: 412000, credit: 0, balance: 1241900 },
  { date: "2026-03-25", ref: "PYMT-0398", type: "Payment", debit: 0, credit: 500000, balance: 829900 },
  { date: "2026-03-19", ref: "INV-2026-0801", type: "Invoice", debit: 345000, credit: 0, balance: 1329900 },
  { date: "2026-03-10", ref: "PYMT-0372", type: "Payment", debit: 0, credit: 250000, balance: 984900 },
  { date: "2026-03-05", ref: "INV-2026-0845", type: "Invoice", debit: 192000, credit: 0, balance: 1234900 },
];

const STATUS_COLORS = {
  "In Transit": { bg: "#dbeafe", color: "#1d4ed8" },
  "Out for Delivery": { bg: "#fef3c7", color: "#92400e" },
  "Delivered": { bg: "#dcfce7", color: "#166534" },
  "Booked": { bg: "#f3e8ff", color: "#6b21a8" },
  "Overdue": { bg: "#fee2e2", color: "#991b1b" },
  "Due Soon": { bg: "#fef3c7", color: "#92400e" },
  "Current": { bg: "#dcfce7", color: "#166534" },
  "Open": { bg: "#fee2e2", color: "#991b1b" },
  "In Progress": { bg: "#fef3c7", color: "#92400e" },
  "Resolved": { bg: "#dcfce7", color: "#166534" },
  "High": { bg: "#fee2e2", color: "#991b1b" },
  "Medium": { bg: "#fef3c7", color: "#92400e" },
  "Low": { bg: "#dcfce7", color: "#166534" },
};

// ── SMALL COMPONENTS ───────────────────────────────────────────────────────
const Badge = ({ label, status }) => {
  const c = STATUS_COLORS[status || label] || { bg: "#f1f5f9", color: "#475569" };
  return <span style={{ background: c.bg, color: c.color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: 0.2, whiteSpace: "nowrap" }}>{label}</span>;
};

const Btn = ({ children, variant = "primary", onClick, full, size = "md", disabled }) => {
  const v = {
    primary: { bg: R, color: WHITE, border: "none" },
    secondary: { bg: WHITE, color: NAVY2, border: `1px solid ${BORDER}` },
    ghost: { bg: "transparent", color: R, border: `1.5px solid ${R}` },
    danger: { bg: "#fee2e2", color: "#991b1b", border: "none" },
    success: { bg: "#dcfce7", color: "#166534", border: "none" },
  }[variant];
  const p = size === "sm" ? "5px 14px" : size === "lg" ? "11px 28px" : "8px 20px";
  return <button disabled={disabled} onClick={onClick} style={{ ...v, padding: p, borderRadius: 8, fontSize: size === "sm" ? 12 : 13, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, fontFamily: "inherit", width: full ? "100%" : "auto", transition: "all 0.15s", whiteSpace: "nowrap" }}
    onMouseEnter={e => !disabled && (e.currentTarget.style.opacity = "0.88")}
    onMouseLeave={e => !disabled && (e.currentTarget.style.opacity = "1")}>{children}</button>;
};

const Card = ({ children, style = {} }) => (
  <div style={{ background: WHITE, borderRadius: 14, border: `1px solid ${BORDER}`, padding: 20, ...style }}>{children}</div>
);

const SectionTitle = ({ title, sub, action }) => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 18, gap: 12, flexWrap: "wrap" }}>
    <div style={{ minWidth: 0 }}>
      <h2 style={{ margin: 0, fontSize: "clamp(15px, 5vw, 17px)", fontWeight: 700, color: NAVY }}>{title}</h2>
      {sub && <p style={{ margin: "3px 0 0", fontSize: 13, color: MUTED }}>{sub}</p>}
    </div>
    {action}
  </div>
);

const KpiCard = ({ label, value, sub, icon, accent }) => (
  <Card style={{ padding: "18px 20px" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.8 }}>{label}</span>
      <span style={{ fontSize: 22, lineHeight: 1 }}>{icon}</span>
    </div>
    <div style={{ fontSize: "clamp(18px, 4vw, 26px)", fontWeight: 800, color: accent || NAVY, fontFamily: "'DM Mono', monospace", lineHeight: 1.1 }}>{value}</div>
    {sub && <div style={{ fontSize: 12, color: MUTED, marginTop: 5 }}>{sub}</div>}
  </Card>
);

const ProgressBar = ({ pct, color = R, height = 6 }) => (
  <div style={{ background: "#f1f5f9", borderRadius: 99, height, overflow: "hidden" }}>
    <div style={{ background: color, height: "100%", width: `${pct}%`, borderRadius: 99, transition: "width 0.6s" }} />
  </div>
);

const Input = ({ label, placeholder, type = "text", value, onChange, required }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}{required && <span style={{ color: R }}> *</span>}</label>}
    <input type={type} value={value} onChange={onChange} placeholder={placeholder} style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${BORDER}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box", color: NAVY2 }} />
  </div>
);

const Sel = ({ label, children, required }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}{required && <span style={{ color: R }}> *</span>}</label>}
    <select style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${BORDER}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", color: NAVY2 }}>{children}</select>
  </div>
);

// ── MOBILE TABLE → CARD LIST ───────────────────────────────────────────────
// Renders a table on desktop, stacked cards on mobile
function ResponsiveTable({ columns, rows, isMobile }) {
  if (!isMobile) {
    return (
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f8fafc" }}>
              {columns.map(col => (
                <th key={col.key} style={{ padding: "9px 14px", textAlign: "left", fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, borderBottom: `1px solid ${BORDER}`, whiteSpace: "nowrap" }}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri} style={{ borderBottom: `1px solid #f8fafc` }}
                onMouseEnter={e => e.currentTarget.style.background = "#fafafa"}
                onMouseLeave={e => e.currentTarget.style.background = ""}>
                {columns.map(col => (
                  <td key={col.key} style={{ padding: "10px 14px", ...col.tdStyle }}>{col.render ? col.render(row) : row[col.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // Mobile: card layout
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {rows.map((row, ri) => (
        <div key={ri} style={{ border: `1px solid ${BORDER}`, borderRadius: 12, padding: "14px 16px", background: "#fafcff" }}>
          {columns.map(col => (
            <div key={col.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 0", borderBottom: col.key !== columns[columns.length - 1].key ? `1px solid #f1f5f9` : "none", gap: 10, flexWrap: "wrap" }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, flexShrink: 0 }}>{col.label}</span>
              <span style={{ fontSize: 13, textAlign: "right", ...(col.tdStyle || {}) }}>
                {col.render ? col.render(row) : row[col.key]}
              </span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

// ── LOGIN SCREEN ───────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState("");
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sendOTP = () => {
    if (mobile.replace(/\D/g, "").length < 10) { setError("Enter a valid 10-digit mobile number"); return; }
    setSending(true); setError("");
    setTimeout(() => { setSending(false); setStep(2); }, 1200);
  };

  const handleOTPKey = (i, val) => {
    const d = val.replace(/\D/g, "").slice(-1);
    const next = [...otp]; next[i] = d; setOtp(next);
    if (d && i < 5) refs[i + 1].current?.focus();
    if (!d && i > 0) refs[i - 1].current?.focus();
  };

  const handlePaste = (e) => {
    const p = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (p.length === 6) { setOtp(p.split("")); refs[5].current?.focus(); }
  };

  const verify = () => {
    const code = otp.join("");
    if (code.length < 6) { setError("Enter the 6-digit OTP"); return; }
    setVerifying(true); setError("");
    setTimeout(() => { if (code === "123456") { onLogin(); } else { setVerifying(false); setError("Incorrect OTP. Use 123456 for demo."); } }, 1000);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", background: BG, flexDirection: isMobile ? "column" : "row" }}>
      {/* Left panel */}
      <div style={{ width: isMobile ? "100%" : "45%", background: `linear-gradient(145deg, ${NAVY} 0%, #1e3a5f 100%)`, display: "flex", flexDirection: "column", padding: isMobile ? "32px 20px" : "48px 52px", position: "relative", overflow: "hidden", minHeight: isMobile ? "auto" : "100vh" }}>
        <div style={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, background: "rgba(192,57,43,0.15)", borderRadius: "50%" }} />
        <div style={{ position: "absolute", bottom: -100, left: -60, width: 380, height: 380, background: "rgba(255,255,255,0.03)", borderRadius: "50%" }} />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: isMobile ? 32 : 60 }}>
            <div style={{ width: 40, height: 40, background: R, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, color: WHITE, fontSize: 15 }}>BRL</div>
            <div>
              <div style={{ color: WHITE, fontWeight: 700, fontSize: 15, letterSpacing: 0.5 }}>Best Roadways</div>
              <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 11, fontFamily: "'DM Mono', monospace" }}>Customer Portal</div>
            </div>
          </div>
          <h1 style={{ color: WHITE, fontSize: isMobile ? 24 : 32, fontWeight: 800, lineHeight: 1.25, margin: "0 0 16px" }}>Track. Manage.<br /><span style={{ color: "#f87171" }}>Stay in Control.</span></h1>
          <p style={{ color: "rgba(255,255,255,0.55)", fontSize: 14, lineHeight: 1.7, margin: "0 0 40px" }}>Your complete logistics dashboard — track shipments, download PODs, manage outstanding invoices, and raise queries in one place.</p>
          {!isMobile && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {["📦 Real-time shipment tracking", "📄 Instant POD & invoice downloads", "💳 Outstanding & account statement", "🎫 Grievance management with SLA", "📊 MIS reports on demand"].map((f, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, color: "rgba(255,255,255,0.75)", fontSize: 13 }}>
                  <div style={{ width: 6, height: 6, background: R, borderRadius: "50%", flexShrink: 0 }} />
                  {f}
                </div>
              ))}
            </div>
          )}
        </div>
        {!isMobile && (
          <div style={{ position: "relative", zIndex: 1, marginTop: "auto", color: "rgba(255,255,255,0.25)", fontSize: 11 }}>
            © 2026 Best Roadways Limited · 40 Years of Logistics Excellence
          </div>
        )}
      </div>

      {/* Right panel */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: isMobile ? 20 : 40, minHeight: isMobile ? "auto" : "100vh" }}>
        <div style={{ width: "100%", maxWidth: 400 }}>
          {step === 1 ? (
            <div>
              <h2 style={{ fontSize: "clamp(20px, 5vw, 24px)", fontWeight: 800, color: NAVY, margin: "0 0 6px" }}>Welcome back</h2>
              <p style={{ color: MUTED, fontSize: 14, margin: "0 0 32px" }}>Sign in with your registered mobile number</p>
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>Mobile Number</label>
                <div style={{ display: "flex", border: `1.5px solid ${BORDER}`, borderRadius: 10, overflow: "hidden", background: WHITE }}>
                  <div style={{ padding: "10px 14px", background: "#f8fafc", borderRight: `1px solid ${BORDER}`, fontSize: 13, color: MUTED, fontWeight: 600 }}>+91</div>
                  <input value={mobile} onChange={e => { setMobile(e.target.value); setError(""); }} placeholder="98200 12345" style={{ flex: 1, padding: "10px 14px", border: "none", outline: "none", fontSize: 14, fontFamily: "'DM Mono', monospace", color: NAVY2 }} onKeyDown={e => e.key === "Enter" && sendOTP()} maxLength={10} />
                </div>
              </div>
              {error && <div style={{ color: R, fontSize: 12, marginBottom: 12, fontWeight: 600 }}>⚠ {error}</div>}
              <Btn full variant="primary" onClick={sendOTP} disabled={sending} size="lg">{sending ? "Sending OTP..." : "Send OTP →"}</Btn>
              <p style={{ textAlign: "center", marginTop: 16, fontSize: 12, color: MUTED }}>New to the portal? Contact your BRL Key Account Manager</p>
            </div>
          ) : (
            <div>
              <button onClick={() => { setStep(1); setOtp(["","","","","",""]); setError(""); }} style={{ background: "none", border: "none", color: MUTED, cursor: "pointer", fontSize: 13, padding: 0, marginBottom: 20, display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" }}>← Back</button>
              <h2 style={{ fontSize: "clamp(20px, 5vw, 24px)", fontWeight: 800, color: NAVY, margin: "0 0 6px" }}>Enter OTP</h2>
              <p style={{ color: MUTED, fontSize: 13, margin: "0 0 8px" }}>Sent to +91 {mobile}</p>
              <div style={{ background: "#fef3c7", borderRadius: 8, padding: "8px 14px", marginBottom: 24, fontSize: 12, color: "#92400e", fontWeight: 600 }}>Demo OTP: 1 2 3 4 5 6</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 8, marginBottom: 20 }}>
                {otp.map((v, i) => (
                  <input key={i} ref={refs[i]} value={v} onChange={e => handleOTPKey(i, e.target.value)} onPaste={handlePaste} placeholder="·" maxLength={1} inputMode="numeric"
                    style={{ padding: "12px 4px", borderRadius: 8, border: `1.5px solid ${BORDER}`, textAlign: "center", fontSize: "18px", fontWeight: 700, color: NAVY2, fontFamily: "'DM Mono', monospace", outline: "none", transition: "all 0.15s", minWidth: 0, width: "100%" }}
                    onFocus={e => e.currentTarget.style.borderColor = R}
                    onBlur={e => e.currentTarget.style.borderColor = BORDER} />
                ))}
              </div>
              {error && <div style={{ color: R, fontSize: 12, marginBottom: 12, fontWeight: 600 }}>⚠ {error}</div>}
              <Btn full variant="primary" onClick={verify} disabled={verifying} size="lg">{verifying ? "Verifying..." : "Verify & Login →"}</Btn>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── DASHBOARD ──────────────────────────────────────────────────────────────
function Dashboard({ setPage }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Recent invoices columns for ResponsiveTable
  const invColumns = [
    { key: "inv", label: "Invoice No", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY } },
    { key: "cn", label: "CN", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, color: MUTED } },
    { key: "date", label: "Date", tdStyle: { fontSize: 12 } },
    { key: "due", label: "Due Date", tdStyle: { fontSize: 12 } },
    {
      key: "amount", label: "Amount (₹)",
      tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 13, fontWeight: 700, color: NAVY },
      render: r => `₹${r.amount.toLocaleString("en-IN")}`
    },
    {
      key: "aging", label: "Aging",
      render: r => <span style={{ fontSize: 12, color: r.aging > 30 ? R : r.aging > 7 ? AMBER : GREEN, fontWeight: 700 }}>{r.aging}d</span>
    },
    {
      key: "status", label: "Status",
      render: r => <Badge label={r.status} status={r.status} />
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* KPI Row */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 }}>
        <KpiCard label="Credit Limit" value={`₹${(USER.credit_limit / 100000).toFixed(1)}L`} sub="Available" icon="💰" accent={GREEN} />
        <KpiCard label="Credit Used" value={`₹${(USER.credit_used / 100000).toFixed(1)}L`} sub={`${((USER.credit_used / USER.credit_limit) * 100).toFixed(0)}% utilized`} icon="📊" accent={AMBER} />
        <KpiCard label="Total Shipments" value={SHIPMENTS.length} sub="This month" icon="📦" />
        <KpiCard label="Open Grievances" value={GRIEVANCES.filter(g => g.status !== "Resolved").length} sub="Pending resolution" icon="🎫" accent={R} />
      </div>

      {/* Recent Shipment */}
      <Card>
        <SectionTitle title="Recent Shipment" sub="Your latest tracked consignment" action={<Btn size="sm" variant="ghost" onClick={() => setPage("track")}>View All</Btn>} />
        {SHIPMENTS.slice(0, 1).map(s => (
          <div key={s.cn}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12, gap: 10, flexWrap: "wrap" }}>
              <div>
                <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: "clamp(13px, 4vw, 14px)", color: NAVY }}>{s.cn}</div>
                <div style={{ fontSize: 12, color: MUTED, marginTop: 2 }}>{s.from} → {s.to}</div>
              </div>
              <Badge label={s.status} status={s.status} />
            </div>
            <div style={{ fontSize: 12, color: MUTED, marginBottom: 10 }}>{s.pkgs} packages · {s.weight}</div>
            {s.status !== "Booked" && <ProgressBar pct={s.route_pct} color={s.status === "Out for Delivery" ? AMBER : BLUE} />}
          </div>
        ))}
      </Card>

      {/* Quick Actions */}
      <Card>
        <SectionTitle title="Quick Actions" />
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(3, 1fr)" : "repeat(6, 1fr)", gap: 10 }}>
          {[
            { icon: "🔍", label: "Track Shipment", page: "track" },
            { icon: "📄", label: "Download POD", page: "documents" },
            { icon: "💳", label: "Outstanding", page: "outstanding" },
            { icon: "🎫", label: "Grievance", page: "grievances" },
            { icon: "📅", label: "Schedule Pickup", page: "pickup" },
            { icon: "📊", label: "MIS Reports", page: "reports" },
          ].map(q => (
            <button key={q.page} onClick={() => setPage(q.page)} style={{ background: BG, border: `1px solid ${BORDER}`, borderRadius: 10, padding: "12px 6px", cursor: "pointer", textAlign: "center", transition: "all 0.15s", fontFamily: "inherit" }}
              onMouseEnter={e => { e.currentTarget.style.background = "#fff5f5"; e.currentTarget.style.borderColor = R; }}
              onMouseLeave={e => { e.currentTarget.style.background = BG; e.currentTarget.style.borderColor = BORDER; }}>
              <div style={{ fontSize: 20, marginBottom: 4 }}>{q.icon}</div>
              <div style={{ fontSize: isMobile ? 10 : 11, fontWeight: 700, color: NAVY2, lineHeight: 1.3 }}>{q.label}</div>
            </button>
          ))}
        </div>
      </Card>

      {/* Recent Invoices */}
      <Card>
        <SectionTitle title="Recent Invoices" action={<Btn size="sm" variant="ghost" onClick={() => setPage("outstanding")}>View All</Btn>} />
        <ResponsiveTable columns={invColumns} rows={INVOICES.slice(0, 4)} isMobile={isMobile} />
      </Card>
    </div>
  );
}

// ── TRACK SHIPMENT ─────────────────────────────────────────────────────────
function TrackShipment() {
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const filtered = query.length > 2 ? SHIPMENTS.filter(s => s.cn.includes(query.toUpperCase()) || s.lr.includes(query.toUpperCase())) : SHIPMENTS;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const TIMELINE = {
    "Booked": ["Booked"],
    "In Transit": ["Booked", "Picked Up", "In Transit"],
    "Out for Delivery": ["Booked", "Picked Up", "In Transit", "Out for Delivery"],
    "Delivered": ["Booked", "Picked Up", "In Transit", "Out for Delivery", "Delivered"],
  };
  const ALL_STEPS = ["Booked", "Picked Up", "In Transit", "Out for Delivery", "Delivered"];

  return (
    <div>
      <SectionTitle title="Track Shipment" sub="Real-time status across all your consignments" />
      <Card style={{ marginBottom: 18 }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: isMobile ? "wrap" : "nowrap" }}>
          <div style={{ flex: 1, position: "relative", minWidth: 0 }}>
            <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔍</span>
            <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search by CN or LR number…" style={{ width: "100%", padding: "10px 14px 10px 38px", border: `1.5px solid ${BORDER}`, borderRadius: 10, fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
          </div>
          <Btn variant="primary" onClick={() => {}}>Search</Btn>
        </div>
      </Card>

      <div style={{ display: "grid", gridTemplateColumns: isMobile || !selected ? "1fr" : "1fr 1.2fr", gap: 16 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {filtered.map(s => (
            <Card key={s.cn} style={{ cursor: "pointer", border: selected?.cn === s.cn ? `2px solid ${R}` : `1px solid ${BORDER}`, transition: "all 0.15s" }}>
              <div onClick={() => setSelected(selected?.cn === s.cn ? null : s)}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10, gap: 10, flexWrap: "wrap" }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 14, color: NAVY, wordBreak: "break-word" }}>{s.cn}</div>
                    <div style={{ fontSize: 12, color: MUTED, marginTop: 2 }}>{s.lr} · {s.material}</div>
                  </div>
                  <Badge label={s.status} status={s.status} />
                </div>
                <div style={{ display: "flex", gap: 12, fontSize: 12, color: MUTED, marginBottom: 12, flexWrap: "wrap" }}>
                  <span>📍 {s.from} → {s.to}</span>
                  <span>📦 {s.pkgs} pkgs · {s.weight}</span>
                  <span>📅 ETA: {s.eta}</span>
                </div>
                {s.status !== "Booked" && <ProgressBar pct={s.route_pct} color={s.status === "Delivered" ? GREEN : s.status === "Out for Delivery" ? AMBER : BLUE} />}
              </div>
            </Card>
          ))}
        </div>

        {selected && !isMobile && (
          <Card>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
              <div>
                <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 800, fontSize: 16, color: NAVY }}>{selected.cn}</div>
                <div style={{ fontSize: 12, color: MUTED }}>{selected.consignee}</div>
              </div>
              <button onClick={() => setSelected(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: MUTED }}>✕</button>
            </div>
            <div style={{ marginBottom: 18 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 10 }}>Timeline</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {ALL_STEPS.map((step, i) => {
                  const active = TIMELINE[selected.status]?.includes(step);
                  return (
                    <div key={step} style={{ display: "flex", gap: 12 }}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div style={{ width: 24, height: 24, borderRadius: "50%", background: active ? R : "#e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", color: active ? WHITE : MUTED, fontSize: 12, fontWeight: 700 }}>{i + 1}</div>
                        {i < ALL_STEPS.length - 1 && <div style={{ width: 2, height: 20, background: active && TIMELINE[selected.status]?.includes(ALL_STEPS[i + 1]) ? R : "#e2e8f0", margin: "4px 0" }} />}
                      </div>
                      <div style={{ paddingTop: 2 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: active ? NAVY : MUTED }}>{step}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
}

// ── OUTSTANDING ────────────────────────────────────────────────────────────
function Outstanding() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const overdue = INVOICES.filter(i => i.status === "Overdue");
  const dueSoon = INVOICES.filter(i => i.status === "Due Soon");
  const current = INVOICES.filter(i => i.status === "Current");

  const columns = [
    { key: "inv", label: "Invoice No", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY } },
    { key: "cn", label: "CN", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, color: MUTED } },
    { key: "date", label: "Date", tdStyle: { fontSize: 12 } },
    { key: "due", label: "Due Date", tdStyle: { fontSize: 12 } },
    {
      key: "amount", label: "Amount (₹)",
      tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 13, fontWeight: 700, color: NAVY },
      render: r => `₹${r.amount.toLocaleString("en-IN")}`
    },
    {
      key: "aging", label: "Aging",
      render: r => <span style={{ fontSize: 12, color: r.aging > 30 ? R : r.aging > 7 ? AMBER : GREEN, fontWeight: 700 }}>{r.aging}d</span>
    },
    {
      key: "status", label: "Status",
      render: r => <Badge label={r.status} status={r.status} />
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 }}>
        <KpiCard label="Total Outstanding" value={`₹${(INVOICES.reduce((a, i) => a + i.amount, 0) / 100000).toFixed(1)}L`} sub={`${INVOICES.length} invoices`} icon="💳" />
        <KpiCard label="Overdue" value={overdue.length} sub={`₹${(overdue.reduce((a, i) => a + i.amount, 0) / 100000).toFixed(1)}L`} icon="⚠️" accent={R} />
        <KpiCard label="Due Soon" value={dueSoon.length} sub={`₹${(dueSoon.reduce((a, i) => a + i.amount, 0) / 100000).toFixed(1)}L`} icon="⏰" accent={AMBER} />
        <KpiCard label="Current" value={current.length} sub={`₹${(current.reduce((a, i) => a + i.amount, 0) / 100000).toFixed(1)}L`} icon="✓" accent={GREEN} />
      </div>

      <Card>
        <SectionTitle title="All Invoices" />
        <ResponsiveTable columns={columns} rows={INVOICES} isMobile={isMobile} />
      </Card>

      <Card>
        <SectionTitle title="Credit Limit Status" />
        <div style={{ marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: NAVY }}>Credit Utilization</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: AMBER }}>₹{(USER.credit_used / 100000).toFixed(1)}L / ₹{(USER.credit_limit / 100000).toFixed(1)}L</span>
          </div>
          <ProgressBar pct={(USER.credit_used / USER.credit_limit) * 100} color={((USER.credit_used / USER.credit_limit) * 100) > 70 ? R : AMBER} height={8} />
        </div>
      </Card>
    </div>
  );
}

// ── UNBILLED ───────────────────────────────────────────────────────────────
function Unbilled() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = [
    { key: "cn", label: "CN", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY } },
    { key: "lr", label: "LR", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, color: MUTED } },
    { key: "route", label: "Route", tdStyle: { fontSize: 12 } },
    { key: "date", label: "Date", tdStyle: { fontSize: 12 } },
    { key: "pkgs", label: "Pkgs", tdStyle: { fontSize: 12 } },
    { key: "weight", label: "Weight", tdStyle: { fontSize: 12 } },
    { key: "material", label: "Material", tdStyle: { fontSize: 12 } },
    {
      key: "days", label: "Days Pending",
      render: r => <span style={{ fontSize: 12, fontWeight: 700, color: r.days > 5 ? R : MUTED }}>{r.days}d</span>
    },
  ];

  return (
    <div>
      <SectionTitle title="Unbilled Consignments" sub="CNs awaiting invoice generation" />
      <Card>
        <ResponsiveTable columns={columns} rows={UNBILLED} isMobile={isMobile} />
      </Card>
    </div>
  );
}

// ── DOCUMENTS & POD ────────────────────────────────────────────────────────
function Documents() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = [
    { key: "cn", label: "CN", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY } },
    { key: "lr", label: "LR", tdStyle: { fontFamily: "'DM Mono', monospace", fontSize: 12, color: MUTED } },
    {
      key: "status", label: "Status",
      render: r => <Badge label={r.status} status={r.status} />
    },
    {
      key: "pod", label: "POD",
      render: r => <span style={{ fontSize: 12, color: r.pod ? GREEN : MUTED, fontWeight: r.pod ? 700 : 400 }}>{r.pod ? "✓ Available" : "—"}</span>
    },
    { key: "invoice", label: "Invoice", tdStyle: { fontSize: 12, fontFamily: "'DM Mono', monospace" } },
    {
      key: "action", label: "Action",
      render: r => (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          <Btn size="sm" variant="ghost" onClick={() => alert(`Downloading invoice for ${r.cn}`)}>Invoice</Btn>
          {r.pod && <Btn size="sm" variant="success" onClick={() => alert(`Downloading POD for ${r.cn}`)}>POD</Btn>}
        </div>
      )
    },
  ];

  return (
    <div>
      <SectionTitle title="Documents & POD" sub="Download proofs of delivery and invoices" />

      {/* Summary strip */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(3,1fr)", gap: 14, marginBottom: 20 }}>
        <KpiCard label="Total Shipments" value={SHIPMENTS.length} sub="All consignments" icon="📦" />
        <KpiCard label="POD Available" value={SHIPMENTS.filter(s => s.pod).length} sub="Ready to download" icon="📄" accent={GREEN} />
        <KpiCard label="POD Pending" value={SHIPMENTS.filter(s => !s.pod).length} sub="Awaiting delivery" icon="⏳" accent={AMBER} />
      </div>

      <Card>
        <ResponsiveTable columns={columns} rows={SHIPMENTS} isMobile={isMobile} />
      </Card>
    </div>
  );
}

// ── GRIEVANCES ─────────────────────────────────────────────────────────────
function Grievances() {
  const [expanded, setExpanded] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <SectionTitle title="Grievances" sub="Track and manage your support tickets" />
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {GRIEVANCES.map(g => (
          <Card key={g.id} style={{ cursor: "pointer", background: g.status === "In Progress" ? "#fffbeb" : WHITE }} onClick={() => setExpanded(expanded === g.id ? null : g.id)}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10, gap: 10, flexWrap: "wrap" }}>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
                  <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 13, color: NAVY }}>{g.id}</div>
                  <Badge label={g.priority} status={g.priority} />
                </div>
                <div style={{ fontSize: 13, fontWeight: 600, color: NAVY, marginBottom: 4 }}>{g.subject}</div>
                <div style={{ fontSize: 12, color: MUTED }}>CN: {g.cn} · Raised: {g.raised}</div>
              </div>
              <Badge label={g.status} status={g.status} />
            </div>

            {expanded === g.id && (
              <div style={{ marginTop: 14, paddingTop: 14, borderTop: `1px solid ${BORDER}` }}>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(120px, 1fr))", gap: 14, marginBottom: 14 }}>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 4 }}>Assigned To</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: NAVY }}>{g.assigned}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 4 }}>SLA</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: g.elapsed_hours > g.sla_hours ? R : GREEN }}>{g.elapsed_hours}/{g.sla_hours} hrs</div>
                  </div>
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 10 }}>Updates</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {g.updates.map((u, i) => (
                    <div key={i} style={{ paddingLeft: 16, borderLeft: `2px solid ${BORDER}` }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: MUTED }}>{u.time}</div>
                      <div style={{ fontSize: 12, color: NAVY, marginTop: 2 }}>{u.msg}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}

// ── SCHEDULE PICKUP ────────────────────────────────────────────────────────
function SchedulePickup() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [form, setForm] = useState({ date: "", time: "", location: "", contact: "" });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <SectionTitle title="Schedule Pickup" sub="Request a pickup from your location" />
      <Card style={{ maxWidth: isMobile ? "100%" : 600 }}>
        <Input label="Preferred Date" type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} required />
        <Input label="Preferred Time" type="time" value={form.time} onChange={e => setForm({ ...form, time: e.target.value })} required />
        <Input label="Pickup Location" placeholder="Enter your pickup address" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} required />
        <Input label="Contact Number" type="tel" placeholder="9820012345" value={form.contact} onChange={e => setForm({ ...form, contact: e.target.value })} required />
        <Btn full variant="primary" onClick={() => alert("Pickup request submitted!")}>Request Pickup</Btn>
      </Card>
    </div>
  );
}

// ── RATE ENQUIRY ───────────────────────────────────────────────────────────
function RateEnquiry() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [form, setForm] = useState({ from: "", to: "", weight: "", pkgs: "" });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <SectionTitle title="Rate Enquiry" sub="Get a quote for your shipment" />
      <Card style={{ maxWidth: isMobile ? "100%" : 600 }}>
        <Sel label="From" required>
          <option>—</option>
          <option>Delhi</option>
          <option>Mumbai</option>
          <option>Chennai</option>
        </Sel>
        <Sel label="To" required>
          <option>—</option>
          <option>Delhi</option>
          <option>Mumbai</option>
          <option>Chennai</option>
        </Sel>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          <Input label="Weight (kg)" type="number" placeholder="100" value={form.weight} onChange={e => setForm({ ...form, weight: e.target.value })} required />
          <Input label="Packages" type="number" placeholder="10" value={form.pkgs} onChange={e => setForm({ ...form, pkgs: e.target.value })} required />
        </div>
        <Btn full variant="primary" onClick={() => alert("Rate enquiry submitted!")}>Get Quote</Btn>
      </Card>
    </div>
  );
}

// ── MIS REPORTS ────────────────────────────────────────────────────────────
function MISReports() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <SectionTitle title="MIS Reports" sub="Download comprehensive logistics reports" />
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(250px, 1fr))", gap: 14 }}>
        {[
          { title: "Monthly Shipment Summary", desc: "Total shipments, delivered, pending", icon: "📊" },
          { title: "Outstanding Statement", desc: "Detailed aging & payment status", icon: "💳" },
          { title: "Performance Scorecard", desc: "On-time %, damage %, SLA compliance", icon: "⭐" },
          { title: "Cost Analysis", desc: "Route-wise, material-wise breakdown", icon: "💰" },
        ].map((r, i) => (
          <Card key={i} style={{ cursor: "pointer" }} onClick={() => alert(`Downloading: ${r.title}`)}>
            <div style={{ fontSize: 24, marginBottom: 10 }}>{r.icon}</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: NAVY, marginBottom: 4 }}>{r.title}</div>
            <div style={{ fontSize: 12, color: MUTED, marginBottom: 12 }}>{r.desc}</div>
            <Btn size="sm" variant="ghost" full>Download PDF</Btn>
          </Card>
        ))}
      </div>
    </div>
  );
}

// ── NOTIFICATIONS ──────────────────────────────────────────────────────────
function Notifications() {
  return (
    <div>
      <SectionTitle title="Notifications" sub="Stay updated on your shipments and account" />
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {[
          { icon: "📦", title: "Shipment CN-2026-4521 delivered", time: "2 hours ago", type: "Delivery" },
          { icon: "⚠️", title: "Invoice INV-2026-0892 is overdue", time: "5 hours ago", type: "Overdue" },
          { icon: "✓", title: "Grievance GRV-2026-0039 resolved", time: "1 day ago", type: "Resolution" },
          { icon: "📅", title: "Scheduled pickup for tomorrow", time: "2 days ago", type: "Reminder" },
        ].map((n, i) => (
          <Card key={i}>
            <div style={{ display: "flex", gap: 12 }}>
              <div style={{ fontSize: 20, flexShrink: 0 }}>{n.icon}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: NAVY, marginBottom: 2 }}>{n.title}</div>
                <div style={{ fontSize: 12, color: MUTED }}>{n.time}</div>
              </div>
              <Badge label={n.type} status={n.type === "Overdue" ? "Overdue" : n.type === "Resolution" ? "Resolved" : "Current"} />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

// ── NAV & PORTAL ───────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: "◉", group: null },
  { id: "track", label: "Track Shipment", icon: "🔍", group: "SHIPMENTS" },
  { id: "pickup", label: "Schedule Pickup", icon: "📅", group: "SHIPMENTS" },
  { id: "rate", label: "Rate Enquiry", icon: "💰", group: "SHIPMENTS" },
  { id: "outstanding", label: "Outstanding", icon: "💳", group: "FINANCE" },
  { id: "unbilled", label: "Unbilled CNs", icon: "📄", group: "FINANCE" },
  { id: "documents", label: "Documents & POD", icon: "📥", group: "FINANCE" },
  { id: "reports", label: "MIS Reports", icon: "📊", group: "FINANCE" },
  { id: "grievances", label: "Grievances", icon: "🎫", group: "SUPPORT" },
  { id: "notifications", label: "Notifications", icon: "🔔", group: "SUPPORT" },
];

function Portal({ onLogout }) {
  const [page, setPage] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const groups = [...new Set(NAV_ITEMS.map(n => n.group))];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const titles = {
    dashboard: "Dashboard", track: "Track Shipment", pickup: "Schedule Pickup",
    rate: "Rate Enquiry", outstanding: "Outstanding", unbilled: "Unbilled CNs",
    documents: "Documents & POD", reports: "MIS Reports", grievances: "Grievances", notifications: "Notifications"
  };

  const sidebarWidth = isMobile ? 260 : 230;
  const mainPadding = isMobile ? 16 : 32;

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: BG, fontFamily: "'Outfit', 'DM Sans', sans-serif", position: "relative" }}>
      {/* Mobile overlay */}
      {isMobile && sidebarOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 10 }} onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <div style={{
        width: sidebarWidth, background: NAVY, flexShrink: 0, display: "flex", flexDirection: "column",
        position: isMobile ? "fixed" : "fixed",
        height: "100vh", overflowY: "auto", zIndex: 20, top: 0, left: 0,
        transform: isMobile && !sidebarOpen ? "translateX(-100%)" : "translateX(0)",
        transition: "transform 0.3s",
      }}>
        <div style={{ padding: "20px 18px 16px", borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
            <div style={{ width: 36, height: 36, background: R, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, color: WHITE, fontSize: 13, flexShrink: 0 }}>BRL</div>
            <div>
              <div style={{ color: WHITE, fontWeight: 700, fontSize: 13 }}>Best Roadways</div>
              <div style={{ color: "rgba(255,255,255,0.35)", fontSize: 10, fontFamily: "'DM Mono', monospace" }}>Customer Portal</div>
            </div>
          </div>
          <div style={{ background: "rgba(255,255,255,0.07)", borderRadius: 10, padding: "10px 12px" }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: WHITE, marginBottom: 2 }}>{USER.name}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)" }}>{USER.company}</div>
          </div>
        </div>

        <div style={{ flex: 1, padding: "10px 0" }}>
          {groups.map(group => (
            <div key={group || "main"}>
              {group && <div style={{ padding: "12px 18px 5px", fontSize: 9, fontWeight: 700, color: "rgba(255,255,255,0.22)", textTransform: "uppercase", letterSpacing: 1.5 }}>{group}</div>}
              {NAV_ITEMS.filter(n => n.group === group).map(item => (
                <button key={item.id} onClick={() => { setPage(item.id); if (isMobile) setSidebarOpen(false); }}
                  style={{ display: "flex", alignItems: "center", gap: 9, width: "100%", padding: "8px 18px", background: page === item.id ? "rgba(192,57,43,0.22)" : "none", border: "none", borderLeft: `3px solid ${page === item.id ? R : "transparent"}`, color: page === item.id ? WHITE : "rgba(255,255,255,0.5)", cursor: "pointer", fontSize: 13, fontWeight: page === item.id ? 600 : 400, fontFamily: "inherit", textAlign: "left", transition: "all 0.12s" }}
                  onMouseEnter={e => { if (page !== item.id) e.currentTarget.style.color = "rgba(255,255,255,0.82)"; }}
                  onMouseLeave={e => { if (page !== item.id) e.currentTarget.style.color = "rgba(255,255,255,0.5)"; }}>
                  <span style={{ fontSize: 14 }}>{item.icon}</span>{item.label}
                  {item.id === "grievances" && GRIEVANCES.filter(g => g.status !== "Resolved").length > 0 && (
                    <span style={{ marginLeft: "auto", background: R, color: WHITE, borderRadius: 99, fontSize: 10, fontWeight: 700, padding: "1px 6px" }}>{GRIEVANCES.filter(g => g.status !== "Resolved").length}</span>
                  )}
                </button>
              ))}
            </div>
          ))}
        </div>

        <div style={{ padding: "14px 18px", borderTop: "1px solid rgba(255,255,255,0.07)" }}>
          <button onClick={onLogout} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.4)", cursor: "pointer", fontSize: 12, fontFamily: "inherit", display: "flex", alignItems: "center", gap: 6, width: "100%" }}>
            ← Sign Out
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ marginLeft: isMobile ? 0 : sidebarWidth, flex: 1, padding: `${mainPadding}px`, display: "flex", flexDirection: "column", minWidth: 0 }}>
        {/* Top bar */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, gap: 10, flexWrap: "wrap" }}>
          {isMobile && (
            <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: NAVY, padding: 0, display: "flex", alignItems: "center", flexShrink: 0 }}>☰</button>
          )}
          <h1 style={{ margin: 0, fontSize: "clamp(16px, 5vw, 20px)", fontWeight: 800, color: NAVY, flex: 1, minWidth: 0 }}>{titles[page]}</h1>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            {!isMobile && (
              <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 8, padding: "6px 14px", fontSize: 12, color: MUTED }}>Mon, 7 Apr 2026</div>
            )}
            <div style={{ width: 36, height: 36, background: R, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: WHITE, fontSize: 13, cursor: "pointer", flexShrink: 0 }}>
              {USER.name.split(" ").map(n => n[0]).join("")}
            </div>
          </div>
        </div>

        {/* Page content */}
        <div style={{ flex: 1, overflowY: "auto" }}>
          {page === "dashboard" && <Dashboard setPage={setPage} />}
          {page === "track" && <TrackShipment />}
          {page === "outstanding" && <Outstanding />}
          {page === "documents" && <Documents />}
          {page === "grievances" && <Grievances />}
          {page === "pickup" && <SchedulePickup />}
          {page === "rate" && <RateEnquiry />}
          {page === "reports" && <MISReports />}
          {page === "notifications" && <Notifications />}
          {page === "unbilled" && <Unbilled />}
        </div>
      </div>
    </div>
  );
}

// ── ROOT ───────────────────────────────────────────────────────────────────
export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=DM+Mono:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        body { margin: 0; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
        ::-webkit-scrollbar-track { background: transparent; }
        input:focus, select:focus, textarea:focus { border-color: #c0392b !important; box-shadow: 0 0 0 3px rgba(192,57,43,0.1) !important; }
        @media (max-width: 768px) {
          body { font-size: 14px; }
        }
      `}</style>
      {loggedIn ? <Portal onLogout={() => setLoggedIn(false)} /> : <LoginScreen onLogin={() => setLoggedIn(true)} />}
    </>
  );
}
